var {AmpersandState} = require('catalog/libs');

var CatalogListingMarqueeView = require('./hpe.catalog.marquee.view');

var CatalogListingMarqueeController = AmpersandState.extend({

    /**
     * controller properties
     */
    props: {
        view: 'object'
    },

    /**
     * initialization
     */
    initialize: function () {
        this.view = new CatalogListingMarqueeView.CatalogListingMarqueeView();
    }
});

module.exports = {CatalogListingMarqueeController};
